import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, createVNode as _createVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-ee8590da"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "Landsholds" }
const _hoisted_2 = { class: "display-2 mt-4 mb-4 postHeadline" }
const _hoisted_3 = { key: 0 }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", { class: "display-4 mt-4 mb-4" }, "Landshold", -1))
const _hoisted_5 = { class: "landHoldMainContainer" }
const _hoisted_6 = { key: 1 }
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", { class: "display-4 mt-4 mb-4" }, "Brutto", -1))
const _hoisted_8 = { class: "landHoldMainContainer" }
const _hoisted_9 = { key: 2 }
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", { class: "display-4 mt-4 mb-4" }, "Talenttrup", -1))
const _hoisted_11 = { class: "landHoldMainContainer" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_va_image = _resolveComponent("va-image")!
  const _component_va_card_title = _resolveComponent("va-card-title")!
  const _component_va_card_content = _resolveComponent("va-card-content")!
  const _component_va_card = _resolveComponent("va-card")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("h2", _hoisted_2, _toDisplayString(_ctx.postData?.postTitle), 1),
    (_ctx.landsHoldsLandshold?.length > 0)
      ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
          _hoisted_4,
          _createElementVNode("div", _hoisted_5, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.landsHoldsLandshold, (landsHold) => {
              return (_openBlock(), _createBlock(_component_va_card, {
                class: "landsHoldsContain",
                key: landsHold.id
              }, {
                default: _withCtx(() => [
                  (landsHold.landshold_billede || landsHold.landshold_billede_url)
                    ? (_openBlock(), _createBlock(_component_va_image, {
                        key: 0,
                        src: `${_ctx.APIURL}${landsHold?.landshold_billede_url ? landsHold?.landshold_billede_url : landsHold?.landshold_billede}`,
                        alt: "landshold"
                      }, null, 8, ["src"]))
                    : (_openBlock(), _createBlock(_component_va_image, {
                        key: 1,
                        src: "https://i.stack.imgur.com/l60Hf.png",
                        alt: "landshold"
                      })),
                  _createVNode(_component_va_card_title, { class: "landsHoldCardTitle" }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(landsHold.landshold_navn), 1)
                    ]),
                    _: 2
                  }, 1024),
                  _createVNode(_component_va_card_content, { class: "landsHoldCardContent" }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(landsHold.landshold_klub), 1)
                    ]),
                    _: 2
                  }, 1024)
                ]),
                _: 2
              }, 1024))
            }), 128))
          ])
        ]))
      : _createCommentVNode("", true),
    (_ctx.landsHoldsBrutto?.length > 0)
      ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
          _hoisted_7,
          _createElementVNode("div", _hoisted_8, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.landsHoldsBrutto, (landsHold) => {
              return (_openBlock(), _createBlock(_component_va_card, {
                class: "landsHoldsContain",
                key: landsHold.id
              }, {
                default: _withCtx(() => [
                  (landsHold.landshold_billede || landsHold.landshold_billede_url)
                    ? (_openBlock(), _createBlock(_component_va_image, {
                        key: 0,
                        src: `${_ctx.APIURL}${landsHold?.landshold_billede_url ? landsHold?.landshold_billede_url : landsHold?.landshold_billede}`,
                        alt: "landshold"
                      }, null, 8, ["src"]))
                    : (_openBlock(), _createBlock(_component_va_image, {
                        key: 1,
                        src: "https://i.stack.imgur.com/l60Hf.png",
                        alt: "landshold"
                      })),
                  _createVNode(_component_va_card_title, { class: "landsHoldCardTitle" }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(landsHold.landshold_navn), 1)
                    ]),
                    _: 2
                  }, 1024),
                  _createVNode(_component_va_card_content, { class: "landsHoldCardContent" }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(landsHold.landshold_klub), 1)
                    ]),
                    _: 2
                  }, 1024)
                ]),
                _: 2
              }, 1024))
            }), 128))
          ])
        ]))
      : _createCommentVNode("", true),
    (_ctx.landsHoldsTalenttrup?.length > 0)
      ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
          _hoisted_10,
          _createElementVNode("div", _hoisted_11, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.landsHoldsTalenttrup, (landsHold) => {
              return (_openBlock(), _createBlock(_component_va_card, {
                class: "landsHoldsContain",
                key: landsHold.id
              }, {
                default: _withCtx(() => [
                  (landsHold.landshold_billede || landsHold.landshold_billede_url)
                    ? (_openBlock(), _createBlock(_component_va_image, {
                        key: 0,
                        src: `${_ctx.APIURL}${landsHold?.landshold_billede_url ? landsHold?.landshold_billede_url : landsHold?.landshold_billede}`,
                        alt: "landshold"
                      }, null, 8, ["src"]))
                    : (_openBlock(), _createBlock(_component_va_image, {
                        key: 1,
                        src: "https://i.stack.imgur.com/l60Hf.png",
                        alt: "landshold"
                      })),
                  _createVNode(_component_va_card_title, { class: "landsHoldCardTitle" }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(landsHold.landshold_navn), 1)
                    ]),
                    _: 2
                  }, 1024),
                  _createVNode(_component_va_card_content, { class: "landsHoldCardContent" }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(landsHold.landshold_klub), 1)
                    ]),
                    _: 2
                  }, 1024)
                ]),
                _: 2
              }, 1024))
            }), 128))
          ])
        ]))
      : _createCommentVNode("", true)
  ]))
}